// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function button10_mouseIn(event) {
	//Add your code for this event here: 
	wixWindow.lightbox.open();
}

$w.onReady(() => {
    waitForLoading();
});
 
export function button6_onClick(event) {
    $w('#preloader').show();
    waitForLoading();
}
 
function waitForLoading() {
    setTimeout(() => {
        $w('#preloader').hide('FadeOut');
    }, 3000);
}

$w.onReady(() => {
    waitForLoading();
});